import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import NextLink from "next/link";
import { useEffect, useRef } from "react";

gsap.registerPlugin(ScrollTrigger);

export const CtaSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!sectionRef.current) return;
    const ctx = gsap.context(() => {
      gsap.fromTo(
        contentRef.current,
        { y: 50, opacity: 0, scale: 0.97 },
        {
          y: 0,
          opacity: 1,
          scale: 1,
          duration: 0.9,
          ease: "power2.out",
          scrollTrigger: { trigger: sectionRef.current, start: "top 80%" },
        },
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={sectionRef} className="py-20 md:py-32 px-6">
      <div
        ref={contentRef}
        className="max-w-5xl mx-auto rounded-[2rem] px-8 py-16 md:py-24 text-center opacity-0"
        style={{ background: "linear-gradient(135deg, #8debcf 0%, #b8f0dc 50%, #fdfeff 100%)" }}
      >
        <h2 className="text-2xl md:text-5xl font-bold tracking-tight text-brand-black mb-4">
          Ready to Eat Better?
        </h2>
        <p className="text-gray-700 text-base md:text-lg max-w-lg mx-auto mb-10">
          Join thousands of customers who trust Visionary Meals for clean, delicious, fully-prepped
          food delivered weekly to your door or nearest pickup location.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <NextLink
            href="/menu"
            className="px-8 py-3.5 md:px-10 md:py-4 bg-gray-900 text-white font-semibold rounded-full text-base md:text-lg hover:bg-gray-800 transition-colors"
          >
            Start Your Order
          </NextLink>
          <a
            href="https://forms.office.com/r/e3Pnv94UV8"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-3.5 md:px-10 md:py-4 bg-white text-brand-black font-semibold rounded-full text-base md:text-lg border border-gray-200 hover:border-gray-400 transition-colors"
          >
            Become an Affiliate
          </a>
        </div>
      </div>
    </section>
  );
};
